import { noop } from "lodash";

import { AdjustImagesComponent } from "./AdjustImagesComponent";
import type { AdjustImagesProps } from "./types";

export const AdjustImages = ({
  onClose,
  onCompleted = noop,
  isOnTop = false,
  editingImageSignedId,
}: AdjustImagesProps) => (
  <AdjustImagesComponent
    open
    onClose={onClose}
    onCompleted={onCompleted}
    isOnTop={isOnTop}
    editingImageSignedId={editingImageSignedId}
  />
);
